import React from 'react';
import { formatDoctorName } from '../../../../utils/common';
import { CardCloseSVG } from './CardViewSVG';
import {
  ProviderImageMen,
  ProviderImageWomen,
  ProviderImageUnknownGender,
  FacilityIcon,
} from '../../../../img/findcare/FindCareSVG';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../redux/admin/priceCompareSlice';
import './CardView.scss';

const CardView = ({ data }) => {
  const {
    DoctorTitle,
    LastName,
    FirstName,
    MiddleName,
    Suffix,
    Gender,
    Specialties,
    PhysicianID,
    Experiance,
    ConnectorId,
    FacilitySpeciality,
    FacilityName,
  } = data;
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  const { selectedCheckedItems, selectedCheckedRowData, providerType } =
    useSelector(({ priceCompareAdmin }) => priceCompareAdmin);
  const removeItem = (phyId) => {
    dispatch(
      setSelectedCheckedItems(
        selectedCheckedItems.filter((id) => id !== phyId),
      ),
    );
    dispatch(
      setSelectedCheckedRowData(
        selectedCheckedRowData.filter((item) => item?.ConnectorId !== phyId),
      ),
    );
  };

  return (
    <div className="card-container">
      <div
        aria-label="Remove this provider from the selected options"
        className="close-icon"
        onClick={() => removeItem(ConnectorId)}
      >
        <CardCloseSVG />
      </div>
      <div className="card-view">
        <div className="content-container">
          <div>
            {Provider === 'facility' ? (
              <FacilityIcon
                className="image-color"
                circleClassName="circle-color"
              />
            ) : (
              <>
                {Gender === 'Male' && (
                  <ProviderImageMen
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}
                {Gender === 'Female' && (
                  <ProviderImageWomen
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}
                {(!Gender?.trim() || Gender?.trim() === 'Unknown') && (
                  <ProviderImageUnknownGender
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}
              </>
            )}
          </div>
          <div className="ml-3 column-last">
            {Provider === 'facility' ? (
              <p className="m-0 provider-name">{FacilityName}</p>
            ) : (
              <p className="m-0 provider-name">
                {formatDoctorName(
                  DoctorTitle ? DoctorTitle : '',
                  LastName ? LastName : '',
                  FirstName ? FirstName : '',
                  MiddleName ? MiddleName : '',
                  Suffix ? Suffix : '',
                )}
              </p>
            )}
            <p className="m-0 provider-spacality">
              {Provider === 'facility'
                ? FacilitySpeciality && FacilitySpeciality.join(', ')
                : Specialties && Specialties.join(', ')}
            </p>
            <p className="m-0 provider-experience">
              {Experiance && `${Experiance} in Practice`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardView;
